package com.essntl.features.invoice.ui.addeditinvoice.components.content.day

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.essntl.features.category.domain.model.CategoryModel
import com.essntl.features.itinerary.domain.model.ItineraryServiceModel
import com.essntl.features.proposal.domain.model.ProposalServiceModel

@Composable
fun rememberAddEditProposalServiceList(
    allProposalServices: List<ProposalServiceModel>,
    invoiceProposalServices: List<ProposalServiceModel>,
    proposalServices: List<ProposalServiceModel>,
    categoryList: List<CategoryModel>?,
    checkedServiceIds: Set<String>,
): List<InvoicingDayUiState.ServiceUiState> {
    return remember(
        allProposalServices,
        invoiceProposalServices,
        proposalServices,
        categoryList,
        checkedServiceIds,
    ) {
        allProposalServices.map { proposalService ->
            val category = categoryList
                .orEmpty()
                .find { it.id == proposalService.service.category }

            val isChecked = proposalService.id in checkedServiceIds

            InvoicingDayUiState.ServiceUiState(
                id = proposalService.id,
                isChecked = isChecked,
                name = proposalService.service.title,
                price = proposalService.price ?: 0,
                iconUrl = category?.iconUrl,
                status = when {
                    invoiceProposalServices.any { it.id == proposalService.id } &&
                        proposalServices.none { it.id == proposalService.id } ->
                        ServiceInvoiceStatus.REMOVING

                    proposalService.paid == true ->
                        ServiceInvoiceStatus.PAID

                    invoiceProposalServices.any { it.id == proposalService.id } &&
                        proposalServices.any { it.id == proposalService.id } ->
                        ServiceInvoiceStatus.INVOICED

                    else ->
                        if (isChecked) ServiceInvoiceStatus.ADDING
                        else ServiceInvoiceStatus.NOT_INVOICED
                },
            )
        }
    }
}

@Composable
fun rememberAddEditItineraryServiceList(
    allItineraryServices: List<ItineraryServiceModel>,
    invoiceItineraryServices: List<ItineraryServiceModel>,
    itineraryServices: List<ItineraryServiceModel>,
    categoryList: List<CategoryModel>?,
    checkedServiceIds: Set<String>,
): List<InvoicingDayUiState.ServiceUiState> {
    return remember(
        allItineraryServices,
        invoiceItineraryServices,
        itineraryServices,
        categoryList,
        checkedServiceIds,
    ) {
        allItineraryServices.map { itineraryService ->
            val category = categoryList
                .orEmpty()
                .find { it.id == itineraryService.service.category }

            val isChecked = itineraryService.id in checkedServiceIds

            InvoicingDayUiState.ServiceUiState(
                id = itineraryService.id,
                isChecked = isChecked,
                name = itineraryService.service.title,
                price = itineraryService.price ?: 0,
                iconUrl = category?.iconUrl,
                status = when {
                    itineraryService.status == ItineraryServiceModel.Status.Cancelled ->
                        ServiceInvoiceStatus.REMOVING

                    invoiceItineraryServices.any { it.id == itineraryService.id } &&
                        itineraryServices.any { it.id == itineraryService.id } ->
                        ServiceInvoiceStatus.INVOICED

                    else ->
                        if (isChecked) ServiceInvoiceStatus.ADDING
                        else ServiceInvoiceStatus.NOT_INVOICED
                },
            )
        }
    }
}